module.exports = __webpack_public_path__ + "static/artist-marketing-hero-mobile-1cb2071a7f9edf193103a1c93cdf84e4.webp";